import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71152fc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "word" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_letter_tile = _resolveComponent("letter-tile")!
  const _component_yellow_letters = _resolveComponent("yellow-letters")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wordData.greenLetters, (_, index) => {
      return (_openBlock(), _createBlock(_component_letter_tile, {
        class: "letter-tile",
        key: `letter-${_ctx.rowIndex}${index}`,
        color: _ctx.getColor(index),
        letter: _ctx.getLetter(index),
        style: _normalizeStyle({
                transform: `scale(${_ctx.lettersScale[index]})`,
                transition: `transform ${_ctx.animduration}ms`,
            })
      }, null, 8, ["color", "letter", "style"]))
    }), 128)),
    _createVNode(_component_yellow_letters, {
      letters: _ctx.wordData.yellowLetters,
      style: _normalizeStyle({
                transform: `scale(${_ctx.lettersScale[5]})`,
                transition: `transform ${_ctx.animduration}ms`,
            })
    }, null, 8, ["letters", "style"])
  ]))
}